export enum AccessLevels {
  A1 = 'A1',
  A2 = 'A2',
  F2_A = 'F2_A',
  F1 = 'F1',
  F2 = 'F2',
}

export type AccessLevel =
  | AccessLevels.A1
  | AccessLevels.A2
  | AccessLevels.F2_A
  | AccessLevels.F1
  | AccessLevels.F2;

export type AccessLevelData = {
  requestedLevel: AccessLevel;
  requestedAt: string;
  mandateEnd: string;
  mandateName?: string;
  mandateAdministration?: string;
  mandateContactPersonEmail?: string;
  officeName?: string;
  officeOrgunitHeadEmail?: string;
  officeStreet?: string;
  officePostcode?: number;
  officeLocation?: string;
};

export type DeclinedAccessLevelRequest = {
  requestedAccessLevel: AccessLevel;
  declineReason: string;
  declinedAt: string;
};
